

class KeycloakHelper
{

    constructor(keycloakInstance) {
        if (keycloakInstance) this.keycloakInstance = keycloakInstance;
    }

    redirectToLoginWithCustomMessage(customMessage, email) {

        const encodedMessage = encodeURIComponent(customMessage);
        this.keycloakInstance.login({
            redirectUri: `${window.location.origin}/ui/&customMessage=` + encodedMessage,
            loginHint: email,
        });
    }
}


export default KeycloakHelper;